<template>
    <a-spin :spinning="loading">
        <div class="card-list">
            <a-card :bordered="false" v-for="(item, index) in cardList" :key="index"
                style="width: 100%; margin-bottom: 20px;">
                <div class="card-header" style="display: flex; align-items: center;">
                    <div class="flex grid-gap-8 align-items-center" style="width:350px">
                        <div>{{ $t('message.strategyManagement.tabTitle1') }}: </div>
                        <a-select v-model="item.selectedUseCase" mode="multiple" :maxTagPlaceholder="maxTagPlaceholder"
                            :placeholder="$t('message.strategyManagement.tabTitle1')" :maxTagCount="1"
                            style="width: 250px" @change="handleUseCaseChange(item)" :options="optionList">
                        </a-select>
                    </div>

                    <div class="card-title">{{ `Hello! Here's your recent ${item.action_type} activity.` }}</div>
                    <div class="toggle-group" style="width:350px;text-align: right;">
                        <a-radio-group v-model="item.period_type" button-style="solid" :defaultValue="form.period_type"
                            @change="handlePeriodChange(item)">
                            <a-radio-button value="Wk">Wk</a-radio-button>
                            <a-radio-button value="Mo">Mo</a-radio-button>
                        </a-radio-group>
                    </div>
                </div>
                <div class="stats">
                    <div class="stat-item" v-for="(stat, statIndex) in item.overall_stats" :key="statIndex"
                        @click="toggleSeries(item, statIndex, index)" :style="{
                            cursor: 'pointer',
                            border: item.chartInstance && item.chartInstance.getOption().legend[0].selected[stat.label]
                                ? `1px solid ${stat.color}`
                                : '1px solid #ccc'
                        }">
                        <div class="stat-label">{{ stat.label }}</div>
                        <div class="stat-value" :style="{ color: stat.color }">
                            {{ stat.value }}
                            <span v-if="stat.percent" class="stat-percent">({{ stat.percent }})</span>
                        </div>
                    </div>
                </div>
                <div class="chart-container">
                    <div :id="`email-activity-chart-${index}`" style="width: 100%; height: 400px"></div>
                </div>
            </a-card>
        </div>
    </a-spin>
</template>
<script>
import echarts from 'echarts'
import usedDashboard from '@/interface/pages/Strategy/usedDashboard.js'
import _ from 'lodash'
export default {
    name: 'Dashboard',
    components: {

    },
    data() {
        return {
            optionList: [],
            form: {
                period_type: 'Wk',
                use_case_list: [],
                action_type: []
            },
            loading: false,
            statColor: ['#2f4050', '#87d068', '#1f7e9f', '#13c2c2', '#d33a3a', '#fa541c'],
            cardList: []

        }
    },
    mounted() {
        window.addEventListener('resize', this.handleChartsResize)
        this.getUseCaseOptionList()
        this.getUseCaseDashboard()
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleChartsResize)
        this.cardList.forEach(item => {
            if (item.chartInstance) {
                item.chartInstance.dispose()
                item.chartInstance = null
            }
        })
    },
    methods: {
        maxTagPlaceholder() {
            return (omittedValues) => {
                let length = omittedValues.length
                let title = []
                omittedValues.forEach(item => {
                    if (this.optionList.find(i => i.value === item)) {
                        title.push(this.optionList.find(i => i.value === item).label)
                    }
                })
                return (
                    <span title={title.join(',')}>+{length}</span>
                )
            }
        },
        async getUseCaseOptionList() {
            try {
                const { data: res } = await usedDashboard.getUseCaseOptionList(this, {})
                if (res.code === '200') {
                    this.optionList = res.data.map(item => {
                        return {
                            ...item,
                            label: item.use_case_name,
                            value: item.use_case_id
                        }
                    })
                } else {
                    this.$message.error(res.message)
                }
            } catch (err) {
                console.log(err)
            } finally {
            }
        },

        async getUseCaseDashboard() {
            try {
                this.loading = true;
                const { data: res } = await usedDashboard.getUseCaseDashboard(this, { data: { ...this.form, time_zone: localStorage.getItem('time_zone') } })
                if (res.code === '200') {
                    this.cardList = res.data.reduce((acc, newItem) => {
                        const existingIndex = acc.findIndex(item => item.action_type === newItem.action_type);

                        if (existingIndex >= 0) {
                            acc[existingIndex] = {
                                ...newItem,
                                chartInstance: acc[existingIndex].chartInstance,
                                overall_stats: newItem.overall_stats.map((stat, index) => ({
                                    ...stat,
                                    color: this.statColor[index]
                                })),
                                selectedUseCase: newItem.use_case_list
                            };
                        } else {
                            acc.push({
                                ...newItem,
                                chartInstance: null,
                                overall_stats: newItem.overall_stats.map((stat, index) => ({
                                    ...stat,
                                    color: this.statColor[index]
                                }))
                            });
                        }
                        return acc;
                    }, [...this.cardList]);
                    setTimeout(() => {
                        this.initCharts()
                        this.handleChartsResize()
                    }, 500)
                } else {
                    this.$message.error(res.message)
                }
            } catch (err) {
                console.log(err)
            } finally {
                this.loading = false
            }
        },
        initCharts() {
            const chartList = this.cardList
            chartList.forEach((item, index) => {
                item.chartInstance = echarts.init(document.getElementById(`email-activity-chart-${index}`)),
                    this.renderChart(item)
            })
            this.cardList = chartList
        },
        renderChart(item) {

            const xAxisData = item.stats_by_dates.dates
            const legendData = item.overall_stats.map(stat => stat.label);
            const selected = {};
            item.overall_stats.forEach((stat, index) => {
                selected[stat.label] = true; // 默认全部选中
            });

            this.option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross'
                    }
                },
                legend: {
                    show: false,
                    data: legendData,
                    selected: selected
                },
                xAxis: {
                    type: 'category',
                    data: xAxisData,
                    boundaryGap: false
                },
                yAxis: {
                    type: 'value'
                },
                series: item.overall_stats.map(stat => ({
                    name: stat.label,
                    type: 'line',
                    data: item.stats_by_dates[stat.label],
                    showSymbol: false
                }))
            }
            item.chartInstance.setOption(this.option)
        },
        handleUseCaseChange: _.debounce(function (item) {
            this.form = {
                ...this.form,
                action_type: [item.action_type],
                use_case_list: item.selectedUseCase
            };
            this.getUseCaseDashboard();
        }, 1000),
        handlePeriodChange(item) {
            this.form = {
                ...this.form,
                action_type: [item.action_type],
                period_type: item.period_type
            }
            this.getUseCaseDashboard()
        },
        handleChartsResize() {
            this.cardList.forEach(item => {
                if (item.chartInstance) {
                    item.chartInstance.resize()
                }
            })
        },
        toggleSeries(item, statIndex, cardIndex) {
            const chartDom = document.getElementById(`email-activity-chart-${cardIndex}`);
            if (!chartDom) return;

            const chart = echarts.getInstanceByDom(chartDom);
            if (!chart) return;

            const option = chart.getOption();
            if (!option.legend || !option.legend[0] || !option.series || !option.series[statIndex]) return;

            const seriesName = option.series[statIndex].name;
            const newSelected = {
                ...option.legend[0].selected,
                [seriesName]: !option.legend[0].selected[seriesName]
            };

            chart.setOption({
                legend: {
                    selected: newSelected
                }
            });
        },

    }
}
</script>

<style scoped>
.card-list {
    padding: 20px;
}

.card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px;
}

.stats {
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    justify-content: center;
    padding: 0 16px 16px;
    gap: 16px;
}

.stat-item {
    min-width: 120px;
    padding: 16px;
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.09);
    text-align: center;
}

.stat-label {
    font-size: 14px;
    color: #999;
    margin-bottom: 8px;
}

.stat-value {
    font-size: 16px;
    font-weight: bold;
}

.stat-percent {
    font-size: 14px;
    margin-left: 4px;
    color: #666;
}

.card-title {
    font-size: 18px;
    font-weight: bold;
    color: #f08000;
}

.chart-container {
    margin-top: -48px
}
</style>